<template>
    <li>
        <div v-if="!!settings" class="uk-grid uk-grid-small">
            <div class="uk-width-1-2">
                <div class="uk-grid uk-grid-small">
                    <div class="uk-width-1-1">
                        <div class="uk-panel uk-panel-box">
                            <h3 class="uk-panel-title">General Settings</h3>

                            <form class="uk-form">
                                <div class="uk-margin-bottom">
                                    Projects are considered "Recently completed" for
                                    <form-input
                                        id="length_of_recently_completed"
                                        name="length_of_recently_completed"
                                        v-model="settings.length_of_recently_completed"
                                        type="number"
                                        :min="1"
                                        format="0,0"
                                        :editable="true"
                                        :required="false"
                                        :error="has_error('length_of_recently_completed')"
                                        class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                        @input="save_field"
                                    />
                                    day(s) after they are completed
                                </div>
                                <div class="uk-margin-bottom">
                                    Comparable project sizes are within a
                                    <form-input
                                        id="comparable_size"
                                        name="comparable_size"
                                        v-model="settings.comparable_size"
                                        type="number"
                                        :min="0"
                                        :max="100"
                                        format="0,0"
                                        glyph="percent"
                                        :editable="true"
                                        :required="false"
                                        :error="has_error('comparable_size')"
                                        class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                        @input="save_field"
                                    />
                                    range.
                                </div>
                                <div class="uk-margin-bottom">
                                    Default day for dates
                                    <form-input
                                        id="default_date_day"
                                        name="default_date_day"
                                        v-model="settings.default_date_day"
                                        type="number"
                                        :min="1"
                                        :max="28"
                                        format="0"
                                        :editable="true"
                                        :required="false"
                                        :error="has_error('default_date_day')"
                                        class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                        @input="save_field"
                                    />
                                    <br><small class="text-muted">(When entering dates as month-year only, which day should the date default to?)</small>
                                </div>
                                <div class="uk-margin-bottom">
                                    Phases are billed the foolwing month if the start at least
                                    <form-input
                                        id="billing_schedule_cut_off"
                                        name="billing_schedule_cut_off"
                                        v-model="settings.billing_schedule_cut_off"
                                        type="number"
                                        :min="0"
                                        format="0,0"
                                        :editable="true"
                                        :required="false"
                                        :error="has_error('billing_schedule_cut_off')"
                                        class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                        @input="save_field"
                                    />
                                    day(s) before the end of the month
                                </div>

                                <div class="uk-margin-bottom">
                                    <h4>Project Awarded Date Reminders</h4>

                                    <ol>
                                        <li class="uk-margin-bottom">On the planned awarded date</li>
                                        <li class="uk-margin-bottom">
                                            <form-input
                                                id="project_awarded_at_nag_delay"
                                                name="project_awarded_at_nag_delay"
                                                v-model="settings.project_awarded_at_nag_delay"
                                                type="number"
                                                :min="0"
                                                format="0,0"
                                                :editable="true"
                                                :required="false"
                                                :error="has_error('project_awarded_at_nag_delay')"
                                                class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                                @input="save_field"
                                            />
                                            <em>business</em> day(s) after the planned awarded date
                                        </li>
                                        <li class="uk-margin-bottom">
                                            Every
                                            <form-input
                                                id="project_awarded_at_nag_every"
                                                name="project_awarded_at_nag_every"
                                                v-model="settings.project_awarded_at_nag_every"
                                                type="number"
                                                :min="0"
                                                format="0,0"
                                                :editable="true"
                                                :required="false"
                                                :error="has_error('project_awarded_at_nag_every')"
                                                class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                                @input="save_field"
                                            />
                                            day(s) after the planned awarded date
                                        </li>
                                    </ol>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="uk-width-1-1">
                        <div class="uk-panel uk-panel-box">
                            <h3 class="uk-panel-title">Holidays</h3>

                            <form class="uk-form">
                                <ul class="uk-list uk-list-space">
                                    <li
                                        v-for="holiday in holidays"
                                        :key="holiday.id"
                                    >
                                        <div class="uk-grid uk-grid-small">
                                            <div class="uk-width-5-10">
                                                <form-input
                                                    :id="`holiday-${holiday.id}-name`"
                                                    name="name"
                                                    v-model="holiday.name"
                                                    :editable="true"
                                                    :required="false"
                                                    :error="has_error('name')"
                                                    class="uk-width-1-1"
                                                    @input="save_holiday_field(holiday, $event, 'name')"
                                                />
                                            </div>
                                            <div class="uk-width-4-10">
                                                <form-date-range-control
                                                    :id="`holiday-${holiday.id}-range`"
                                                    name="starts_at"
                                                    end-name="ends_at"
                                                    calendar-position="top"
                                                    :value="holiday"
                                                    :editable="true"
                                                    :required="false"
                                                    :legacy="false"
                                                    @change="save_holiday_field(holiday, $event, 'range')"
                                                />
                                            </div>
                                            <div class="uk-width-1-10">
                                                <base-button
                                                    color="danger"
                                                    @click.prevent="delete_holiday(holiday)"
                                                >
                                                    <open-icon glyph="trash" />
                                                </base-button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="uk-grid uk-grid-small">
                                            <div class="uk-width-5-10">
                                                <form-input
                                                    :id="`holiday-new-name`"
                                                    name="name"
                                                    v-model="new_holiday.name"
                                                    :editable="true"
                                                    :required="false"
                                                    :error="has_error('name')"
                                                    class="uk-width-1-1"
                                                />
                                            </div>
                                            <div class="uk-width-4-10">
                                                <form-date-range-control
                                                    :id="`holiday-new-range`"
                                                    name="starts_at"
                                                    end-name="ends_at"
                                                    calendar-position="top"
                                                    :value="new_holiday"
                                                    :editable="true"
                                                    :required="false"
                                                    :legacy="false"
                                                    @change="merge_holiday_data(new_holiday, $event)"
                                                />
                                            </div>
                                            <div class="uk-width-1-10">
                                                <base-button
                                                    color="primary"
                                                    @click.prevent="create_holiday"
                                                >
                                                    <open-icon glyph="plus" />
                                                </base-button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uk-width-1-2">
                <div class="uk-grid uk-grid-small">
                    <div class="uk-width-1-1">
                        <div class="uk-panel uk-panel-box">
                            <h3 class="uk-panel-title">Communications Settings</h3>

                            <form class="uk-form">
                                <div class="uk-margin-bottom">
                                    Warn of upcoming due dates
                                    <form-input
                                        id="due_date_delay"
                                        name="due_date_delay"
                                        v-model="settings.due_date_delay"
                                        type="number"
                                        :min="1"
                                        format="0,0"
                                        :editable="true"
                                        :required="false"
                                        :error="has_error('due_date_delay')"
                                        class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                        @input="save_field"
                                    />
                                    day(s) before
                                </div>
                                <div class="uk-margin-bottom">
                                    Remind PMs to complete the project every
                                    <form-input
                                        id="project_complete_delay"
                                        name="project_complete_delay"
                                        v-model="settings.project_complete_delay"
                                        type="number"
                                        :min="1"
                                        format="0,0"
                                        :editable="true"
                                        :required="false"
                                        :error="has_error('project_complete_delay')"
                                        class="uk-width-1-10 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                        @input="save_field"
                                    />
                                    day(s)
                                </div>
                                <div class="uk-margin-bottom">
                                    Engagement Default Message
                                    <form-text-area
                                        id="engagement_message"
                                        name="engagement_message"
                                        v-model="settings.engagement_message"
                                        width="1-1"
                                        size="medium"
                                        :required="false"
                                        class="uk-width-1-1"
                                        @input="save_field"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="uk-width-1-1">
                        <div class="uk-panel uk-panel-box">
                            <h3 class="uk-panel-title">Reporting Settings</h3>

                            <form class="uk-form">
                                <div class="uk-grid uk-grid-small">
                                    <div class="uk-width-2-10 uk-text-right lam-label-column uk-margin-small-bottom">
                                        <div class="uk-form-controls-text">Hours / day</div>
                                    </div>
                                    <div class="uk-width-3-10 uk-margin-small-bottom">
                                        <form-input
                                            id="work_day_hours"
                                            name="work_day_hours"
                                            v-model="settings.work_day_hours"
                                            type="number"
                                            :min="1"
                                            :max="24"
                                            format="0,0"
                                            :editable="true"
                                            :required="false"
                                            :error="has_error('work_day_hours')"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                            @input="save_field"
                                        />
                                    </div>
                                    <div class="uk-width-2-10 uk-text-right lam-label-column uk-margin-small-bottom">
                                        <div class="uk-form-controls-text">Workload slope</div>
                                    </div>
                                    <div class="uk-width-3-10 uk-margin-small-bottom">
                                        <form-input
                                            id="workload_slope"
                                            name="workload_slope"
                                            v-model="settings.workload_slope"
                                            type="float"
                                            :min="0"
                                            :max="100"
                                            format="0,0.0"
                                            glyph="percent"
                                            :editable="true"
                                            :required="false"
                                            :error="has_error('workload_slope')"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                            @input="save_field"
                                        />
                                    </div>
                                    <div class="uk-width-2-10 uk-text-right lam-label-column uk-margin-small-bottom">
                                        <div class="uk-form-controls-text">Billings Min</div>
                                    </div>
                                    <div class="uk-width-3-10 uk-margin-small-bottom">
                                        <form-input
                                            id="billings_min"
                                            name="billings_min"
                                            v-model="settings.billings_min"
                                            type="number"
                                            :min="1"
                                            format="0,0"
                                            glyph="dollar"
                                            :editable="true"
                                            :required="false"
                                            :error="has_error('billings_min')"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                            @input="save_field"
                                        />
                                    </div>
                                    <div class="uk-width-2-10 uk-text-right lam-label-column uk-margin-small-bottom">
                                        <div class="uk-form-controls-text">Target</div>
                                    </div>
                                    <div class="uk-width-3-10 uk-margin-small-bottom">
                                        <form-input
                                            id="billings_target"
                                            name="billings_target"
                                            v-model="settings.billings_target"
                                            type="number"
                                            :min="1"
                                            format="0,0"
                                            glyph="dollar"
                                            :editable="true"
                                            :required="false"
                                            :error="has_error('billings_target')"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                            @input="save_field"
                                        />
                                    </div>
                                    <div class="uk-width-2-10 uk-text-right lam-label-column">
                                        <div class="uk-form-controls-text">Top Clients</div>
                                    </div>
                                    <div class="uk-width-3-10 uk-margin-small-bottom">
                                        <form-input
                                            id="top_clients_slice"
                                            name="top_clients_slice"
                                            v-model="settings.top_clients_slice"
                                            type="number"
                                            :min="1"
                                            format="0,0"
                                            :editable="true"
                                            :required="false"
                                            :error="has_error('top_clients_slice')"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                            @input="save_field"
                                        />
                                    </div>
                                    <div class="uk-width-5-10">
                                        &nbsp;
                                    </div>
                                    <div class="uk-width-2-10 uk-text-right lam-label-column">
                                        <div class="uk-form-controls-text">X</div>
                                    </div>
                                    <div class="uk-width-1-10 uk-margin-small-bottom">
                                        <form-input
                                            id="x"
                                            name="x"
                                            v-model="settings.load_lines.x"
                                            type="number"
                                            :min="0"
                                            format="0,0"
                                            glyph="percent"
                                            :editable="true"
                                            :required="false"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left"
                                            @input="save_load_lines"
                                        />
                                    </div>
                                    <div class="uk-width-1-10 uk-text-right lam-label-column">
                                        <div class="uk-form-controls-text">Y</div>
                                    </div>
                                    <div class="uk-width-1-10 uk-margin-small-bottom">
                                        <form-input
                                            id="y"
                                            name="y"
                                            v-model="settings.load_lines.y"
                                            type="number"
                                            :min="1"
                                            format="0,0"
                                            glyph="percent"
                                            :editable="true"
                                            :required="false"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left"
                                            @input="save_load_lines"
                                        />
                                    </div>
                                    <div class="uk-width-1-10 uk-text-right lam-label-column">
                                        <div class="uk-form-controls-text">Z</div>
                                    </div>
                                    <div class="uk-width-1-10 uk-margin-small-bottom">
                                        <form-input
                                            id="z"
                                            name="z"
                                            v-model="settings.load_lines.z"
                                            type="number"
                                            :min="1"
                                            format="0,0"
                                            glyph="percent"
                                            :editable="true"
                                            :required="false"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left"
                                            @input="save_load_lines"
                                        />
                                    </div>
                                    <div class="uk-width-3-10">
                                        &nbsp;
                                    </div>

                                    <div class="uk-width-1-5 uk-text-right lam-label-column uk-margin-small-top uk-margin-small-bottom">
                                        <div class="uk-form-controls-text">Project Sizes</div>
                                    </div>
                                    <div class="uk-width-4-5 uk-margin-small-top">
                                        <table class="uk-table vertical-borders">
                                            <tbody>
                                                <tr>
                                                    <td class="uk-width-1-5">
                                                        <div class="uk-flex">
                                                            <span class="uk-flex-item-1 uk-margin-small-top">$0</span>
                                                            <span class="uk-flex-item-none uk-margin-small-top uk-margin-small-left uk-margin-small-right">to</span>
                                                            <span class="uk-flex-item-1 uk-margin-small-top uk-text-right">${{ settings.project_sizes[0] - 1 | nibnut.number("0,0") }}</span>
                                                        </div>
                                                    </td>
                                                    <td class="uk-width-3-5">
                                                        <div class="uk-flex">
                                                            <form-input
                                                                id="project_size_lower_limit"
                                                                name="project_size_lower_limit"
                                                                :value="settings.project_sizes[0]"
                                                                type="number"
                                                                :min="1"
                                                                format="0,0"
                                                                glyph="dollar"
                                                                :editable="true"
                                                                :required="false"
                                                                class="uk-flex-item-1"
                                                                @input="save_project_size"
                                                            />
                                                            <span class="uk-flex-item-none uk-margin-small-top uk-margin-small-left uk-margin-small-right">to</span>
                                                            <form-input
                                                                id="project_size_higher_limit"
                                                                name="project_size_higher_limit"
                                                                :value="settings.project_sizes[1]"
                                                                type="number"
                                                                :min="1"
                                                                format="0,0"
                                                                glyph="dollar"
                                                                :editable="true"
                                                                :required="false"
                                                                class="uk-flex-item-1"
                                                                @input="save_project_size"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td class="uk-width-1-5">
                                                        <div class="uk-flex">
                                                            <span class="uk-flex-item-1 uk-margin-small-top">${{ settings.project_sizes[1] + 1 | nibnut.number("0,0") }}</span>
                                                            <span class="uk-flex-item-none uk-margin-small-top uk-margin-small-left uk-margin-small-right">to</span>
                                                            <span class="uk-flex-item-1 uk-margin-small-top uk-text-right">&infin;</span>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr class="uk-text-small">
                                                    <td class="uk-width-1-3 uk-text-center">
                                                        Small
                                                    </td>
                                                    <td class="uk-width-1-3 uk-text-center">
                                                        Medium
                                                    </td>
                                                    <td class="uk-width-1-3 uk-text-center">
                                                        Large
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="uk-width-1-5 uk-text-right lam-label-column uk-margin-small-top">
                                        <div class="uk-form-controls-text">Worksheet URL</div>
                                    </div>
                                    <div class="uk-width-4-5 uk-margin-small-top">
                                        <form-input
                                            id="office_workload_reporting_worksheet_url"
                                            name="office_workload_reporting_worksheet_url"
                                            v-model="settings.office_workload_reporting_worksheet_url"
                                            :editable="true"
                                            :required="false"
                                            :error="has_error('office_workload_reporting_worksheet_url')"
                                            class="uk-width-1-1 uk-display-inline-block uk-margin-small-left uk-margin-small-right"
                                            @input="save_field"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="uk-width-1-1">
                        <div class="uk-panel uk-panel-box">
                            <h3 class="uk-panel-title">
                                Crystal Ball
                                <base-button
                                    flavor="link"
                                    size="small"
                                    class="uk-margin-small-left"
                                    @click.prevent="regenerate"
                                >
                                    <open-icon glyph="refresh" /> Re-generate values
                                </base-button>
                            </h3>

                            <form class="uk-form">
                                <div class="uk-grid uk-grid-small">
                                    <div class="uk-width-2-10 uk-text-right lam-label-column uk-margin-small-bottom">
                                        <div class="uk-form-controls-text">Avg Hourly Rate</div>
                                    </div>
                                    <div class="uk-width-3-10">
                                        <div class="uk-button-group uk-width-1-1">
                                            <base-button
                                                :class="{'uk-active': settings.crystalball_avg_hourly_rate === 0}"
                                                class="uk-width-1-2"
                                                @click.prevent="crystalball_avg_hourly_rate_mode(0)"
                                            >
                                                Auto
                                            </base-button>
                                            <base-button
                                                :class="{'uk-active': settings.crystalball_avg_hourly_rate !== 0}"
                                                class="uk-width-1-2"
                                                @click.prevent="crystalball_avg_hourly_rate_mode(settings.calculated_crystalball_avg_hourly_rate)"
                                            >
                                                 Manual
                                            </base-button>
                                        </div>
                                    </div>
                                    <div
                                        class="uk-text-muted uk-text-right uk-width-2-10 lam-label-column uk-margin-small-bottom"
                                    >
                                        <div class="uk-form-controls-text">(Calc.: $ {{ settings.calculated_crystalball_avg_hourly_rate | nibnut.number("0,0") }} / h)</div>
                                    </div>
                                    <div class="uk-width-3-10 uk-margin-small-bottom">
                                        <div v-if="settings.crystalball_avg_hourly_rate!==0" class="uk-flex uk-flex-middle">
                                            <form-input
                                                id="crystalball_avg_hourly_rate"
                                                name="crystalball_avg_hourly_rate"
                                                v-model="settings.crystalball_avg_hourly_rate"
                                                type="number"
                                                :min="1"
                                                format="0,0"
                                                glyph="dollar"
                                                :editable="true"
                                                :required="false"
                                                :error="has_error('crystalball_avg_hourly_rate')"
                                                class="uk-flex-item-1"
                                                @input="save_field"
                                            />
                                            <span class="uk-flex-none uk-margin-left">/ h</span>
                                        </div>
                                    </div>

                                    <div class="uk-width-2-10 uk-text-right lam-label-column uk-margin-small-bottom">
                                        <div class="uk-form-controls-text">Hit Rates</div>
                                    </div>
                                    <div class="uk-width-3-10 uk-margin-small-bottom">
                                        <div class="uk-button-group uk-width-1-1" data-uk-button-radio>
                                            <base-button
                                                :class="{'uk-active': !!settings.crystalball_hit_rate_auto}"
                                                class="uk-width-1-2"
                                                @click.prevent="crystalball_hit_rate_mode(1)"
                                            >
                                                Auto
                                            </base-button>
                                            <base-button
                                                :class="{'uk-active': !settings.crystalball_hit_rate_auto}"
                                                class="uk-width-1-2"
                                                @click.prevent="crystalball_hit_rate_mode(0)"
                                            >
                                                Manual
                                            </base-button>
                                        </div>
                                    </div>
                                    <div class="uk-width-1-1 uk-margin-top">
                                        <div
                                            v-for="term in types_of_request"
                                            :key="term.id"
                                            class="uk-grid uk-grid-small uk-flex-middle"

                                        >
                                            <div class="uk-width-2-10 uk-text-right lam-label-column uk-margin-small-bottom">
                                                <div>{{ term.name }}</div>
                                            </div>
                                            <div
                                                class="uk-text-muted uk-text-right uk-width-2-10 lam-label-column uk-margin-small-bottom"
                                            >
                                                <div>(Calc.: {{ term.computed_weight | nibnut.number("0,0.0") }})</div>
                                            </div>
                                            <div v-if="!settings.crystalball_hit_rate_auto" class="uk-width-3-10 lam-label-column uk-margin-small-bottom">
                                                <form-input
                                                    :id="`term-${term.id}-weight`"
                                                    name="weight"
                                                    v-model="term.weight"
                                                    type="float"
                                                    :min="0"
                                                    format="0,0.00"
                                                    :editable="true"
                                                    :required="false"
                                                    :error="has_error('weight')"
                                                    class="uk-width-1-1"
                                                    @input="save_term_field(term, ...arguments)"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="uk-width-1-1">
                        <div class="uk-panel uk-panel-box">
                            <h3 class="uk-panel-title">
                                Studios
                                <base-button
                                    flavor="link"
                                    size="small"
                                    class="uk-margin-small-left"
                                    @click.prevent="prompt_studio_name"
                                >
                                    <open-icon glyph="plus" />
                                </base-button>
                            </h3>

                            <div class="uk-grid uk-grid-small">
                                <div
                                    v-for="studio in studios"
                                    :key="studio.id"
                                    class="uk-width-1-2"
                                >
                                    <div class="uk-panel uk-panel-box">
                                        <h3 class="uk-panel-title uk-form">
                                            <form-input
                                                :id="`studio-${studio.id}-name`"
                                                name="name"
                                                v-model="studio.name"
                                                :editable="true"
                                                :required="true"
                                                :error="has_error('name')"
                                                class="uk-width-1-1"
                                                @input="save_studio_field(studio, ...arguments)"
                                            />
                                        </h3>

                                        <form class="uk-form">
                                            <div class="uk-grid uk-grid-small">
                                                <div class="uk-width-5-10 uk-text-right lam-label-column">
                                                    <div class="uk-form-controls-text">Time Off Arbiter</div>
                                                </div>
                                                <div class="uk-width-4-10">
                                                    <form-select-user
                                                        :id="`studio-${studio.id}-arbiter_id`"
                                                        name="arbiter_id"
                                                        v-model="studio.arbiter_id"
                                                        :editable="true"
                                                        :required="false"
                                                        class="uk-width-1-1"
                                                        @input="save_studio_field(studio, ...arguments)"
                                                    />
                                                </div>
                                                <div class="uk-width-1-10">
                                                    <base-button
                                                        color="danger"
                                                        @click.prevent="confirm_delete_studio(studio)"
                                                    >
                                                        <open-icon glyph="trash" />
                                                    </base-button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal-dialog
            id="new-studio-dialog"
            :show.sync="prompting_studio_name"
        >
            <template v-slot:title>
                New Studio
            </template>

            <form class="uk-form">
                <form-input
                    id="new-studio-name`"
                    name="name"
                    v-model="studio_name"
                    :editable="true"
                    :required="true"
                    class="uk-width-1-1"
                >
                    <template v-slot:label>Name</template>
                </form-input>
                <form-select-user
                    id="new-studio-arbiter_id`"
                    name="arbiter_id"
                    v-model="studio_arbiter_id"
                    :editable="true"
                    :required="true"
                >
                    <template v-slot:label>Time Off Arbiter</template>
                    <template v-slot:hint>NOTE: this will move the selected arbiter's studio</template>
                </form-select-user>
            </form>

            <template v-slot:footer>
                <base-button
                    class="uk-margin-small-right"
                    @click.prevent="prompting_studio_name=false"
                >
                    Cancel
                </base-button>
                <base-button
                    color="primary"
                    class="uk-margin-small-left"
                    @click.prevent="create_studio"
                >
                    Create
                </base-button>
            </template>
        </modal-dialog>
        <modal-dialog
            id="delete-studio-dialog"
            :show.sync="confirming_deleted_studio"
        >
            <template v-slot:title>
                Delete Studio {{ deleted_studio.name }}
            </template>

            <form class="uk-form">
                <form-select
                    id="alternate_studio_id"
                    name="alternate_studio_id"
                    v-model="alternate_studio_id"
                    :options="alternate_studios"
                    :editable="true"
                    :disabled="deleting_studio"
                    :required="true"
                    width="1-1"
                >
                    <template v-slot:label>
                        There are {{ deleted_studio.attached_project_count }} project(s) and {{ deleted_studio.attached_user_count }} user(s) attached to this studio. Which studio should we re-assign them to?
                    </template>
                </form-select>
            </form>

            <template v-slot:footer>
                <base-button
                    class="uk-margin-small-right"
                    :disabled="deleting_studio"
                    @click.prevent="confirming_deleted_studio=false"
                >
                    Cancel
                </base-button>
                <base-button
                    color="primary"
                    :waiting="deleting_studio"
                    :disabled="deleting_studio"
                    class="uk-margin-small-left"
                    @click.prevent="delete_studio"
                >
                    Delete & Re-Assign
                </base-button>
            </template>
        </modal-dialog>
    </li>
</template>

<script>
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import is_setting_page from "./IsSettingPage"
import string_utilities from "../../mixins/StringUtilities"

import FormInput from "../../ui/FormInput"
import FormDateRangeControl from "../../ui/FormDateRangeControl"
import FormSelect from "../../ui/FormSelect"
import FormSelectUser from "../../ui/FormSelectUser"
import FormTextArea from "../../ui/FormTextArea"
import ModalDialog from "../../dialogs/ModalDialog/ModalDialog"

export default {
    mixins: [is_setting_page, string_utilities],
    components: {
        FormInput,
        FormDateRangeControl,
        FormSelect,
        FormSelectUser,
        FormTextArea,
        ModalDialog
    },
    methods: {
        load_data () {
            if(this.is_settings_admin) {
                this.$store.dispatch("FETCH_RECORD", { entity: this.entity, id: this.record_id })
            }
        },
        merge_holiday_data (holiday, data) {
            Object.keys(data).forEach(field => {
                holiday[field] = data[field]
            })
        },
        save_load_lines () {
            this.save_field(this.settings.load_lines, "load_lines").then(response => {
                window.nibnut.vue.application_settings.load_lines = this.settings.load_lines
            })
        },
        save_holiday_field (holiday, value, field) {
            if(field === "range") this.merge_holiday_data(holiday, value)
            else holiday[field] = value
            this.save_field(this.settings.holidays, "holidays")
        },
        reset_new_holiday_data () {
            this.new_holiday.name = ""
            this.new_holiday.starts_at = ""
            this.new_holiday.ends_at = ""
        },
        create_holiday () {
            if(!this.new_holiday.name || !this.new_holiday.starts_at || !this.new_holiday.ends_at) {
                this.$error("Please complete the entry first!")
            } else {
                this.settings.holidays.push(this.new_holiday)
                this.save_field(this.settings.holidays, "holidays").then(() => {
                    this.reset_new_holiday_data()
                })
            }
        },
        delete_holiday (holiday) {
            let identifier = holiday.name || ""
            if(!identifier) identifier = "this holiday"

            this.$confirm({
                type: "warning",
                title: "Delete Holiday",
                message: `You grouch: do you really want to delete ${identifier}? You know the holiday will technically still exist for everyone else, right?`,
                cancel: "Keep It",
                ok: "Delete It",
                then: (confirmed) => {
                    if(confirmed) {
                        const holidays = this.holidays.slice()
                        const index = this.holidays.findIndex(day => day.id === holiday.id)
                        if(index >= 0) {
                            holidays.splice(index, 1)
                            this.save_field(holidays, "holidays")
                        }
                    }
                }
            })
        },
        save_studio_field (studio, value, field) {
            this.save_field_for_record_id("studio", studio.id, value, field)
        },
        crystalball_avg_hourly_rate_mode (rate) {
            if(!this.settings) return
            if(this.settings.crystalball_avg_hourly_rate !== rate) {
                if(!rate) this.settings.crystalball_avg_hourly_rate = rate
                else if(!this.settings.crystalball_avg_hourly_rate) this.settings.crystalball_avg_hourly_rate = rate

                if(this.settings.crystalball_avg_hourly_rate === rate) {
                    this.save_field(this.settings.crystalball_avg_hourly_rate, "crystalball_avg_hourly_rate")
                }
            }
        },
        crystalball_hit_rate_mode (auto) {
            if(!this.settings) return
            if(this.settings.crystalball_hit_rate_auto !== auto) {
                this.settings.crystalball_hit_rate_auto = auto
                this.save_field(this.settings.crystalball_hit_rate_auto, "crystalball_hit_rate_auto")
            }
        },
        save_term_field (term, value, field) {
            this.save_field_for_record_id("term", term.id, value, field)
        },
        save_project_size (value, field) {
            value = parseInt(value) || 0
            const index = (field === "project_size_lower_limit") ? 0 : 1
            this.settings.project_sizes[index] = value
            if(this.settings.project_sizes[0] > this.settings.project_sizes[1]) {
                const temp = this.settings.project_sizes[0]
                this.settings.project_sizes[0] = this.settings.project_sizes[1]
                this.settings.project_sizes[1] = temp
            }
            this.save_field(this.settings.project_sizes, "project_sizes")
        },
        regenerate () {
            this.$store.dispatch("RECORD_ACTION",
                {
                    entity: this.entity,
                    id: this.record_id,
                    action: "regenerate",
                    passthru: true,
                    method: "post"
                }
            ).then(() => {
                this.$success(`<strong>Job scheduled</strong><br>I'll send you an email (${this.profile.email}) when I'm done.`)
            }).catch(error => {
                this.$error("<strong>" + error.header + "</strong><br>" + error.message)
            })
        },
        prompt_studio_name () {
            this.studio_name = ""
            this.studio_arbiter_id = 0
            this.prompting_studio_name = true
        },
        create_studio () {
            if(!this.studio_name) this.$error("<strong>Missing name</strong><br />Please provide a name for the new studio")
            else {
                this.$store.dispatch("CREATE_RECORD", {
                    entity: "studio",
                    data: {
                        name: this.studio_name,
                        arbiter_id: 0
                    }
                }).then(() => {
                    this.prompting_studio_name = false
                }).catch(error => {
                    this.$error(error.message)
                })
            }
        },
        confirm_delete_studio (studio) {
            this.deleted_studio = studio
            this.alternate_studio_id = this.alternate_studios[0].id
            this.confirming_deleted_studio = true
        },
        delete_studio () {
            this.deleting_studio = true
            this.$store.dispatch("RECORD_DELETE", {
                entity: "studio",
                id: this.deleted_studio.id,
                data: { alternate_studio_id: this.alternate_studio_id }
            }).then(() => {
                this.confirming_deleted_studio = false
            }).catch(error => {
                this.$error(error.message)
            }).finally(() => {
                this.deleting_studio = false
            })
        }
    },
    computed: {
        ...mapGetters(["entity_record", "entity_records"]),
        settings () {
            return this.entity_record("setting", 1)
        },
        studios () {
            return this.entity_records("studio")
        },
        alternate_studios () {
            if(!this.deleted_studio.id) return this.studios
            return this.studios.filter(studio => studio.id !== this.deleted_studio.id)
        },
        holidays () {
            if(!this.settings || !this.settings.holidays) return []

            return orderBy(this.settings.holidays, holiday => {
                return this.$moment(holiday.starts_at).format("YYYY-MM-DD")
            }, "asc")
        },
        types_of_request () {
            return this.dictionary("type_of_request")
        }
    },
    data () {
        return {
            entity: "setting",
            record_id: 1,

            new_holiday: { id: 0, name: "", starts_at: "", ends_at: "" },

            studio_name: "",
            studio_arbiter_id: 0,
            prompting_studio_name: false,

            deleted_studio: {},
            alternate_studio_id: 0,
            confirming_deleted_studio: false,
            deleting_studio: false
        }
    }
}
</script>
